var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.7 149.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b3a54;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.23,87.35s-12.71,9.16-19.58,17.37c-8.02,9.58-18.15,13.17-25.58,6.22-7.43-6.95-23.89-23.1-41.87-25.93,0,0,13.84,5.98,24.82,16.4,10.31,9.79,16.54,21.65,16.54,33.2,0,10.26-8.78,14.46-8.78,14.46h27.43s-4.39-33.93,27.01-61.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 119.62,
    cy: 103.75,
    rx: 8.23,
    ry: 7.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.45,83.36c3.25-8.09,3.91-16.21,2.34-22.62-5.65,3.75-10.85,10.2-14.1,18.29-3.25,8.09-3.91,16.21-2.34,22.62,5.65-3.75,10.85-10.2,14.1-18.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.79,68.12c4.03-5.06,6.68-12.39,6.93-20.62,.25-8.23-1.95-15.7-5.66-20.97-4.03,5.06-6.68,12.39-6.93,20.62-.25,8.23,1.95,15.7,5.66,20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.91,71c-.61-9.06-3.3-17.08-7.09-22.56-3.03,5.9-4.62,14.18-4.01,23.24,.61,9.06,3.3,17.08,7.09,22.56,3.03-5.9,4.62-14.18,4.01-23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.73,56.53c-5.39-8.4-12.22-14.8-18.77-18.22,.21,7.13,3.08,15.86,8.47,24.27,5.39,8.4,12.22,14.8,18.77,18.22-.21-7.13-3.08-15.86-8.47-24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.88,70.81c-2.35,3.3-3.82,8.03-3.82,13.28s1.47,9.98,3.82,13.28c2.35-3.3,3.82-8.03,3.82-13.28s-1.47-9.98-3.82-13.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.94,98.56c-2.62,3.65-3.95,7.61-3.96,10.97,3.27-1.22,6.65-3.84,9.27-7.49,2.62-3.65,3.95-7.61,3.96-10.97-3.27,1.22-6.65,3.84-9.27,7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.79,51.92c-3.88,1.5-7.42,4.61-9.61,8.87-2.19,4.27-2.59,8.85-1.45,12.7,3.88-1.5,7.42-4.61,9.61-8.87,2.19-4.27,2.59-8.85,1.45-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.19,50.58c.99-2.23,1.07-4.92,0-7.46-1.06-2.54-3.06-4.44-5.38-5.4-.99,2.23-1.07,4.92,0,7.46,1.06,2.54,3.06,4.44,5.38,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.25,57.87c2.59-3.19,4.15-7.72,4.01-12.69-.14-4.98-1.94-9.41-4.71-12.47-2.59,3.19-4.15,7.72-4.01,12.69,.14,4.98,1.94,9.41,4.71,12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.23,38.45c2.1-3.14,2.98-7.26,2.13-11.5-.85-4.24-3.27-7.75-6.43-9.92-2.1,3.14-2.98,7.26-2.13,11.5,.85,4.24,3.27,7.75,6.43,9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.69,49.54c1.46,5.1,4.4,9.27,7.9,11.79,1.66-3.88,1.97-8.9,.5-14-1.46-5.1-4.4-9.27-7.91-11.79-1.66,3.88-1.97,8.9-.5,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.24,33.37c1.6,5.57,4.8,10.11,8.62,12.87,1.82-4.23,2.14-9.71,.55-15.28-1.6-5.57-4.8-10.11-8.62-12.87-1.82,4.24-2.14,9.71-.55,15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.86,96.34c1.06-9.26-1.52-20.14-7.92-30.17-6.4-10.02-15.34-17.18-24.43-20.51-1.06,9.26,1.52,20.14,7.92,30.17,6.4,10.02,15.34,17.18,24.43,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.23,23.9c5.23,3.84,11.06,5.9,16.12,6.08-1.51-4.63-5.11-9.47-10.34-13.31-5.23-3.84-11.06-5.9-16.12-6.08,1.51,4.63,5.11,9.47,10.34,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.78,80.35c8.12,2.83,16.25,3.22,22.66,1.55-3.78-5.22-10.27-9.93-18.39-12.76-8.12-2.83-16.25-3.22-22.66-1.55,3.78,5.22,10.27,9.93,18.39,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.83,90.8c-6.35-2.22-12.72-2.52-17.73-1.21,2.96,4.09,8.04,7.77,14.39,9.99,6.35,2.22,12.72,2.52,17.73,1.21-2.96-4.09-8.04-7.77-14.39-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.76,77.84c-6.82-2.08-13.61-2.01-18.92-.22,3.25,4.4,8.75,8.21,15.57,10.29,6.82,2.08,13.61,2.01,18.92,.22-3.25-4.4-8.75-8.21-15.57-10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.64,58.14c-1.69-5.84-5.27-10.55-9.6-13.35C-.17,49.33-.69,55.13,1,60.97c1.69,5.84,5.27,10.55,9.6,13.35,2.21-4.53,2.73-10.33,1.04-16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.03,40.74c1.31-4.1,.45-8.39-1.97-11.91-4.07,1.63-7.28,4.72-8.59,8.82-1.31,4.1-.45,8.39,1.97,11.91,4.07-1.63,7.28-4.72,8.59-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.57,50.1c-.29-5.69-2.27-10.73-5.21-14.18-2.58,3.7-4.05,8.9-3.76,14.59,.29,5.69,2.27,10.73,5.21,14.18,2.58-3.7,4.05-8.9,3.76-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.04,31.38c3.26-1.08,5.82-3.08,7.28-5.38-2.63-.94-5.94-.98-9.2,.1-3.26,1.08-5.82,3.08-7.28,5.38,2.64,.94,5.94,.98,9.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.38,4.52C78.92,1.73,72.54-.01,65.45,0c-7.09,.01-13.47,1.78-17.91,4.58,4.46,2.79,10.84,4.53,17.93,4.52,7.09-.01,13.47-1.78,17.91-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.69,17.27c3.26-3.63,4.8-8.03,4.62-12.13-4.26,.45-8.58,2.57-11.84,6.2-3.26,3.63-4.8,8.03-4.62,12.13,4.26-.45,8.58-2.57,11.84-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.44,35c-4.71,3.63-8.92,9.63-11.42,16.98-2.5,7.35-2.78,14.57-1.21,20.16,4.71-3.63,8.92-9.63,11.42-16.98,2.5-7.34,2.78-14.57,1.21-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.92,35.2c2.8-2.43,5.16-6.31,6.34-10.96,1.18-4.64,.96-9.13-.35-12.52-2.8,2.43-5.16,6.31-6.34,10.96-1.19,4.64-.96,9.13,.35,12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.01,11.85c-1.8,5.4-1.81,12.42,.39,19.59,2.2,7.18,6.18,13.07,10.74,16.68,1.8-5.4,1.81-12.42-.39-19.59-2.2-7.18-6.18-13.07-10.74-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.18,11.85c.82,6.04,4.16,12.87,9.72,18.89,5.56,6.02,12.24,10.02,18.4,11.54-.82-6.04-4.16-12.87-9.72-18.89-5.56-6.02-12.24-10.02-18.4-11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.77,22.41c-.29,1.72,.08,3.77,1.17,5.7,1.09,1.93,2.69,3.35,4.35,4.05,.29-1.72-.08-3.77-1.17-5.7-1.09-1.93-2.69-3.35-4.35-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.3,21.1c-1.64-.27-3.6,.03-5.45,.97-1.85,.94-3.22,2.32-3.91,3.76,1.64,.27,3.6-.03,5.45-.97,1.85-.94,3.22-2.32,3.91-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.63,95.61c.57-1.8,.49-4.05-.38-6.26-.87-2.22-2.37-3.96-4.04-4.95-.57,1.8-.49,4.05,.38,6.26,.87,2.22,2.37,3.96,4.04,4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.3,91.62c1.73,.95,3.72,1.1,5.49,.56-.4-1.74-1.53-3.31-3.26-4.26-1.73-.95-3.72-1.1-5.49-.56,.4,1.74,1.53,3.31,3.26,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.01,10.44c1.85,.93,3.82,1.24,5.45,.96-.69-1.45-2.06-2.83-3.91-3.76-1.85-.93-3.82-1.24-5.45-.96,.69,1.45,2.06,2.83,3.91,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.22,46.91c.57-3.26-.12-7.16-2.18-10.83-2.06-3.67-5.08-6.37-8.23-7.72-.57,3.26,.12,7.16,2.18,10.83,2.06,3.67,5.08,6.37,8.23,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.74,85.33c-.38-3.78-2.36-7.91-5.78-11.4-3.42-3.49-7.61-5.63-11.52-6.23,.38,3.78,2.36,7.91,5.78,11.4,3.42,3.49,7.61,5.63,11.52,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.27,33.68c.26,2.55,1.59,5.33,3.9,7.68,2.31,2.35,5.13,3.8,7.77,4.2-.26-2.55-1.59-5.33-3.9-7.68-2.31-2.35-5.13-3.8-7.77-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.61,56.93c3.76,4.07,8.13,6.89,12.07,8.11-.78-3.89-3.17-8.39-6.92-12.46-3.76-4.07-8.13-6.89-12.07-8.11,.78,3.89,3.17,8.39,6.92,12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.25,18.42c2.76,1.77,5.8,2.56,8.43,2.39-.84-2.39-2.76-4.79-5.52-6.56-2.76-1.77-5.8-2.56-8.43-2.39,.84,2.39,2.76,4.79,5.52,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.69,19.85c3.34-2.19,5.65-5.14,6.64-8.06-3.21-.17-6.91,.83-10.25,3.02-3.34,2.19-5.65,5.14-6.64,8.06,3.21,.17,6.91-.83,10.25-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.13,71c1.32-2.44,1.87-5.74,1.32-9.24-.55-3.5-2.08-6.51-4.09-8.47-1.32,2.44-1.87,5.74-1.32,9.24,.55,3.5,2.08,6.51,4.09,8.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21ca7f9732968495cb5ed32074c87410.svg";
export { ForwardRef as ReactComponent };